import React from "react";
import { ProducerSummaryPreviewTemplate } from "themes/application/producer/components";

function ProducerSummaryPreview(props) {
    return <ProducerSummaryPreviewTemplate {...props} />;
}

export default ProducerSummaryPreview;
